import {
  LoadingAnimationName,
  loadingAnimationNames,
  loadingAnimationPaths
} from 'features/loading-spinner/loadingAnimationPaths';
import { LottieComponent } from 'features/lottie/LottieComponent';
import { sample } from 'lodash';
import { useState } from 'react';
import styled from 'styled-components';

type Props = {
  animation?: LoadingAnimationName;
  height?: number;
};

export const LottieLoadingAnimation = ({ height = 150, animation }: Props) => {
  const [animationName] = useState(
    () => animation || (sample(loadingAnimationNames) as LoadingAnimationName)
  );
  const loadingAnimationPath = loadingAnimationPaths[animationName];

  return (
    <AnimationContainer $height={height}>
      <LottieComponent src={loadingAnimationPath} options={{ width: '100%' }} />
    </AnimationContainer>
  );
};

const AnimationContainer = styled.div<{ $height: number }>`
  height: ${({ $height }) => $height}px;
`;
